import { useCallback, useContext, useEffect, useMemo } from 'react';

import { message } from 'antd';

import {
  GenericDataFormContext,
  ModalDeleteTab,
  QuotationInfoContext,
  QuotationStepButtons,
} from '../../../../../shared';
import { Tabs } from '@hdi-seguros/web-components.tabs';

import {
  QUOTATION_BUTTON,
  QuotationStep,
} from '../../../../../shared/interfaces';

import { StepTwoFormContext } from '../../contexts/StepTwoForm';
import { Form } from '../../../../../../../../../shared/components';
import { WizardDataFormContext } from '../../../../Wizard/contexts/WizardDataForm';

export const PropertyDataCar = () => {
  const { setCurrentStep } = useContext(QuotationInfoContext);
  const { setCanShowSpinner } = useContext(GenericDataFormContext);
  const { stepTwoForm, quotationResponseByCar, reQuotationResponseByCar } =
    useContext(WizardDataFormContext);

  const {
    activeKey,
    addNewTab,
    keyTabToDelete,
    removeTab,
    setActiveKey,
    setKeyTabToDelete,
    setShowModal,
    showModal,
    tabs,
    carFormValues,
    setCarFormValues,
    executeCarQuotations,
    executeCarReQuotations,
    removeVehicleInfo,
    labelButton,
  } = useContext(StepTwoFormContext);

  const hasToReQuote = useMemo(
    () =>
      quotationResponseByCar.length ||
      reQuotationResponseByCar.length ||
      labelButton === QUOTATION_BUTTON.RECOTIZAR,
    [quotationResponseByCar, reQuotationResponseByCar, labelButton]
  );

  const onPressQuotationButton = useCallback(async () => {
    setCanShowSpinner(true);

    try {
      const fieldsToValidate = Object.keys(
        stepTwoForm?.getFieldsValue()
      ).filter((el) => !el.includes('accessory'));
      await stepTwoForm?.validateFields(fieldsToValidate);

      const formValues = stepTwoForm?.getFieldsValue(fieldsToValidate);

      setCarFormValues(formValues);

      return hasToReQuote
        ? await executeCarReQuotations()
        : await executeCarQuotations();
    } catch (error: any) {
      message.error('Debe completar todos los campos');
    } finally {
      setCanShowSpinner(false);
    }
  }, [
    setCanShowSpinner,
    stepTwoForm,
    setCarFormValues,
    executeCarQuotations,
    quotationResponseByCar,
    executeCarReQuotations,
    reQuotationResponseByCar,
    labelButton,
  ]);

  const onChange = (newActiveKey: string) => {
    setActiveKey(newActiveKey);
  };

  const onEdit = (targetKey: any, action: 'add' | 'remove') => {
    if (action === 'add') {
      addNewTab();

      return;
    }

    setShowModal(true);
  };

  const onConfirmModal = useCallback(async () => {
    if (keyTabToDelete !== null) {
      removeTab(keyTabToDelete);
      await removeVehicleInfo(String(keyTabToDelete));
      setKeyTabToDelete(null);
    }

    setShowModal(false);
  }, [
    keyTabToDelete,
    removeTab,
    removeVehicleInfo,
    setKeyTabToDelete,
    setShowModal,
  ]);

  const onCancelModal = useCallback(() => {
    setShowModal(false);
    setKeyTabToDelete(null);
  }, [setShowModal, setKeyTabToDelete]);

  const handlerBackButton = () => {
    setCarFormValues(stepTwoForm?.getFieldsValue());
    setCurrentStep(QuotationStep.ONE);
  };

  useEffect(() => {
    if (carFormValues && Object.keys(carFormValues).length > 0) {
      stepTwoForm?.setFieldsValue(carFormValues);
    }
  }, [carFormValues, stepTwoForm]);

  return (
    <Form
      formProps={{
        name: 'property-data-car',
        form: stepTwoForm,
      }}
    >
      <Tabs
        type='editable-card'
        activeKey={activeKey}
        onEdit={onEdit}
        hideAdd={false}
        items={tabs}
        handlePressTab={onChange}
      />

      <QuotationStepButtons
        label={
          hasToReQuote ? QUOTATION_BUTTON.RECOTIZAR : QUOTATION_BUTTON.COTIZAR
        }
        onClick={onPressQuotationButton}
        onPressBackButton={handlerBackButton}
        htmlType='button'
      />

      <ModalDeleteTab
        open={showModal}
        onCancel={onCancelModal}
        onOk={onConfirmModal}
      />
    </Form>
  );
};
